<template>
  <a-modal
    :title="title"
    :open="open"
    :confirm-loading="submitLoading"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form ref="formRef" :model="form" :rules="rules">
      <a-form-item label="用户名" name="userName">
        <a-input v-model:value="form.userName" :disabled="true" />
      </a-form-item>
      <a-form-item has-feedback label="新密码" name="newPassword">
        <a-input-password
          v-model:value="form.newPassword"
          placeholder="请输入新密码"
          :maxLength="20"
        />
      </a-form-item>
      <a-form-item has-feedback label="确认密码" name="confirmPassword">
        <a-input-password
          v-model:value="form.confirmPassword"
          placeholder="请确认密码"
          :maxLength="20"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import { resetUserPwd } from '@/api/system/user'

defineOptions({
  name: 'ResetPassword',
})

const formRef = ref(null)
const submitLoading = ref(false)
const title = ref('重置密码')
const open = ref(false)

const form = reactive({
  id: undefined,
  userName: undefined,
  newPassword: undefined,
  confirmPassword: undefined,
})

const validateNewPass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入新密码'))
  } else if (
    !/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){5,20}$/.test(
      value
    )
  ) {
    callback(
      new Error(
        '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种'
      )
    )
  } else {
    if (form.confirmPassword !== '') {
      formRef.value?.validateFields(['confirmPassword'])
    }
    callback()
  }
}

const validateConfirmPass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请再次输入新密码确认'))
  } else if (value !== form.newPassword) {
    callback(new Error('两次输入的密码不一致'))
  } else {
    callback()
  }
}

const rules = reactive({
  newPassword: [
    { required: true, validator: validateNewPass, trigger: 'change' },
  ],
  confirmPassword: [
    { required: true, validator: validateConfirmPass, trigger: 'change' },
  ],
})

// 取消按钮
const cancel = () => {
  open.value = false
  reset()
}

// 表单重置
const reset = () => {
  Object.assign(form, {
    id: undefined,
    userName: undefined,
    newPassword: undefined,
    confirmPassword: undefined,
  })
}

const handleResetPwd = (row) => {
  Object.assign(form, {
    id: row.id,
    userName: row.userName,
  })
  open.value = true
}

/** 重置密码按钮操作 */
const submitForm = () => {
  formRef.value.validate().then(() => {
    submitLoading.value = true
    resetUserPwd(form.id, form.newPassword)
      .then((response) => {
        message.success('重置成功', 3)
        open.value = false
      })
      .finally(() => {
        submitLoading.value = false
      })
  }).catch(() => {
    return false
  })
}

// 暴露方法给父组件
defineExpose({
  handleResetPwd,
})
</script>
